import { Category } from './CategoryDetail';
import { HomePageBanner } from './HomePage';
import { Product } from './Product';

export interface ChannelLandingCategoryBlock {
  title: string;
  url: string;
  category?: Category;
  products: Product[];
}

export interface ChannelLandingPageData {
  id?: number;
  url?: string;
  title: string;
  description?: string | null;
  landingUrl?: string | null;
  showCategoryTitle?: number;
  questions?: unknown;
  heroBanners: HomePageBanner[];
  midBanners: HomePageBanner[];
  categories: ChannelLandingCategoryBlock[];
}

export function toRootAbsolutePath(raw?: string | null): string {
  const next = String(raw || '').trim();
  if (!next) return '';
  if (/^https?:\/\//i.test(next)) return next;
  return next.startsWith('/') ? next : `/${next}`;
}

function withRootAbsoluteBannerUrl(banner: HomePageBanner): HomePageBanner {
  return { ...banner, url: toRootAbsolutePath(banner.url) };
}

export function normalizeChannelLandingPage(page: ChannelLandingPageData): ChannelLandingPageData {
  return {
    ...page,
    heroBanners: (page.heroBanners || []).map(withRootAbsoluteBannerUrl),
    midBanners: (page.midBanners || []).map(withRootAbsoluteBannerUrl),
  };
}
